import {Spinner} from 'evergreen-ui';
import React from 'react';
import {Observable} from 'rxjs';
import {useObservable} from 'rxsupport';

type CancelButtonProps = {
    isSubmitting$: Observable<boolean>;
    cancel: () => void
};
export const CancelButton = ({cancel, isSubmitting$}: CancelButtonProps) => {
    const isSubmitting = useObservable(isSubmitting$, false);
    return (
        <button
            type='button'
            onClick={cancel}
            disabled={isSubmitting}
            className='bg-gray-200 h-10 w-32 my-4 py-2 px-1 text-black
                            hover:bg-gray-300 font-sm disabled:opacity-50
                            text-sm focus:outline-none focus:ring rounded'>
            Cancel
        </button>
    );
};

type OkButtonProps = {
    text: string;
    disabled?: boolean;
    submit: () => Promise<void>;
    isSubmitting$: Observable<boolean>;
};
export const OkButton = ({text, disabled = false, submit, isSubmitting$}: OkButtonProps) => {
    const isSubmitting = useObservable(isSubmitting$, false);
    return (
        <button
            type='button'
            onClick={submit}
            disabled={disabled || isSubmitting}
            className={`bg-atlantis-200 h-10 w-32 my-4 py-2 px-1 text-white
                            hover:bg-atlantis-300 font-sm ml-5 disabled:opacity-50
                            text-sm focus:outline-none focus:ring rounded`}>
            {isSubmitting ? <Spinner size={16} marginX='auto'/> : text}
        </button>
    );
}
